namespace SolovisGateway.Admin.EnvironmentPools {

    export class EnvironmentPoolEditorDialog {

        private _saveCallback;
        private _environmentPoolId;
        private _environmentPoolEditor;

        private _dialogWindow: Solovis.UI.Dialog;

        private _savedEnvironmentPoolEditorModel;


        constructor(options) {
            var self = this;

            var desiredWidth = Math.min($(window).width() * .8, 650);
            var desiredHeight = Math.min($(window).height() * .8, 350);

            var minWidth = 100;
            var minHeight = 100;

            this._saveCallback = options.saveCallback ? options.saveCallback : null;
            this._environmentPoolId = options.environmentPoolId ? options.environmentPoolId : null;

            var editorDiv = $("<div>")
                .css("min-height", "75px");

            this._environmentPoolEditor = new SolovisGateway.Admin.EnvironmentPools.EnvironmentPoolEditorControl({
                controlHost: editorDiv,
                environmentPoolId: this._environmentPoolId
            });

            this._environmentPoolEditor.setAsCurrentControl();

            this._dialogWindow = new Solovis.UI.Dialog({
                container: editorDiv,

                title: this._environmentPoolId ? "Edit Environment Pool" : "Add Environment Pool",

                modal: true,
                center: true,
                actions: ["Close"],
                autoOpen: true,
                destroyOnClose: true,
                width: desiredWidth,
                minWidth: minWidth,
                minHeight: minHeight,
                height: desiredHeight,
                buttons: [
                    {
                        label: "Save",
                        click: function () {
                            self._save();
                        }
                    },
                    {
                        label: "Cancel",
                        click: function () {
                            self._dialogWindow.close();
                        }
                    }
                ]
            });
        }


        public _cancel() {
            this._dialogWindow.close();
        }

        public _save() {
            var self = this;

            if (this._environmentPoolEditor.isValid()) {

                var model = this._environmentPoolEditor._getEnvironmentPoolModel();
                Solovis.Rpc.invokeAndWait("~/Admin/EnvironmentPoolAdmin/SetEnvironmentPool",
                    {
                        model: model
                    },
                    function (response, success) {
                        if (success) {
                            if (response.result.modelIsValid) {
                                var savedEnvironmentPoolEditorModel = response.result.modelResult;

                                // Only show notification when adding a new environment pool.
                                var showNotification = self._environmentPoolId ? false : true;
                                self._environmentPoolEditor._savedEnvironmentPoolEditorModel = savedEnvironmentPoolEditorModel;

                                if (showNotification) {
                                    self._environmentPoolEditor.notify({
                                        success: true
                                    });

                                    var saveButton = self._dialogWindow.getButtonByLabel("Save");
                                    if (saveButton) {
                                        saveButton
                                            .text("OK")
                                            .unbind("click")
                                            .click(function () {
                                                self._dialogWindow.close();
                                                if (self._saveCallback) {
                                                    self._saveCallback(savedEnvironmentPoolEditorModel);
                                                }
                                            });
                                    }

                                    var cancelButton = self._dialogWindow.getButtonByLabel("Cancel");
                                    if (cancelButton) {
                                        cancelButton.remove();
                                    }
                                }
                                else {
                                    self._dialogWindow.close();
                                    if (self._saveCallback) {
                                        self._saveCallback(savedEnvironmentPoolEditorModel);
                                    }
                                }

                            }
                            else {
                                self._environmentPoolEditor._formBuilder.applyErrors(response.result.errors);
                            }
                        }
                    });
            }
        }


        public static showDialog(options) {
            var dialog = new SolovisGateway.Admin.EnvironmentPools.EnvironmentPoolEditorDialog(options);
        }
    }

}
